import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Popup } from "./Popup";
import supabase from "../../utils/supabaseClient";

export default function PopupViewer() {
    const [popups, setPopups] = useState([]);

    async function getPopups() {
        if (!supabase) return;

        const { data, error } = await supabase
        .from("popup")
        .select("*")
        .order("created_at", { ascending: false });
        console.log(data, error);
        if (!error) setPopups(data);
    }

    useEffect(() => {
        getPopups();
    }, []);

    if (!supabase) return null;

    return (
        <div className="popup-viewer">
            {popups.filter(popup => popup.hide === false).map((popup) => (
                <div key={popup.id} className="popup">
                    <Popup name={popup.link}>
                        <Link to={popup.link}>
                            <div className="p-0 cursor-pointer">
                                <img src={popup.image_url} alt="" />
                            </div>
                        </Link>
                    </Popup> 
                </div>
            ))}
        </div>
    );
}
